import { useMutation, useQueryClient } from 'react-query';
import { reportArchive } from 'api/reports';
import { useToast } from '@chakra-ui/react';

export const useArchiveReportMutation = () => {
  const queryClient = useQueryClient();
  const toast = useToast();

  return useMutation(reportArchive, {
    onSuccess: () => {
      toast({
        status: 'success',
        title: 'Report Archived',
        description: 'The report was successfully archived',
        isClosable: true,
        duration: 5000,
      });
      queryClient.invalidateQueries({
        queryKey: ['fetch-reports'],
      });
    },
  });
};
